<template>
  <div class="staffing-container">
    <div class="title">
      <label>員工管理</label>
    </div>
    <div class="filter-container">
      <el-cascader
        ref="cascader"
        v-model="listQuery.departmentID"
        filterable
        clearable
        placeholder="所屬組別"
        :options="organizationOptions"
        expand-trigger="hover"
        :props="{
          children: 'childNode',
          value: 'departmentID',
          label: 'departmentName',
          checkStrictly: true,
          emitPath: false
        }"
        :show-all-levels="false"
        class="w160"
        @change="handleChanges"
      />
      <el-select
        v-model="listQuery.roleId"
        placeholder="全部角色"
        clearable
        class="w120"
      >
        <el-option
          v-for="item in roleOptions"
          :key="item.roleID"
          :label="item.roleName"
          :value="item.roleID"
        />
      </el-select>
      <!-- <el-select filterable v-model="listQuery.searchName" placeholder="員工姓名" @input.native="selectOne" @visible-change="getUserLists" @focus='focusValue' class="w120" clearable>
                <el-option v-for="item in users" :key="item.index" :label="item.name" :value="item.name" />
            </el-select> -->
      <!-- @input.native="inputName"  @keydown.native="inputName"-->
      <el-select
        v-model="listQuery.searchName"
        filterable
        remote
        :remote-method="remoteMethods"
        :loading="loading"
        placeholder="員工姓名"
        class="w120"
        clearable
        @visible-change="clearNo"
      >
        <el-option
          v-for="item in nameOptions"
          :key="item.index"
          :label="item.name"
          :value="item.name"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="員工狀態"
        class="w120"
      >
        <el-option
          v-for="item in stateOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select
        v-model="listQuery.isAgentData"
        placeholder="代理人"
        class="w120"
      >
        <el-option
          v-for="item in agentOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-input
        v-model="listQuery.keyWorld"
        class="w160"
        placeholder="電話、電郵"
        suffix-icon="el-icon-search"
        @input="val => listQuery.keyWorld = val ? val.trim() : ''"
      />
      <el-button
        class="search-btn"
        type="primary"
        @click="search"
      >
        搜尋
      </el-button>
      <el-button
        class="reset-btn"
        @click="handleReset"
      >
        重置
      </el-button>
    </div>
    <div
      v-if="permissions.System_Employee_Manager"
      :class="{ 'operationIcon-container': true, fixed: isTop }"
    >
      <span
        class="tooltip add-user"
        placement="top"
        content="新增員工"
        @click="handleCreate"
      >
        <svg
          class="icon"
          aria-hidden="true"
        >
          <use xlink:href="#iconxinzengyuangong-copy" />
        </svg>
        <span class="btn-text">新增員工</span>
      </span>
      <div class="line" />
      <span
        placement="top"
        class="tooltip"
        content="啟用賬戶"
        @click="changeStatus(1)"
      >
        <svg
          class="icon"
          aria-hidden="true"
        >
          <use :xlink:href="iconStart === true && multipleSelection.length > 0 ? '#iconqiyongzhanghu-copy' : '#iconqiyongzhanghu'" />
        </svg>
        <span :class="{ 'btn-text': true, ban: !(iconStart === true && multipleSelection.length > 0) }">啟用賬戶</span>
      </span>
      <span
        placement="top"
        :class="['tooltip', { notclick: iconDisable == false }]"
        content="停用賬戶"
        @click="changeStatus(2)"
      >
        <svg
          class="icon"
          aria-hidden="true"
        >
          <use :xlink:href="iconDisable === true && multipleSelection.length > 0 ? '#icontingyongzhanghu-copy' : '#icontingyongzhanghu'" />
        </svg>
        <span :class="{ 'btn-text': true, ban: !(iconDisable === true && multipleSelection.length > 0) }">停用賬戶</span>
      </span>
      <span
        placement="top"
        class="tooltip"
        content="更改"
        @click="handleUpdate()"
      >
        <svg
          class="icon"
          aria-hidden="true"
          @click="handleUpdate()"
        >
          <use :xlink:href="multipleSelection.length === 1 ? '#iconxiugai-copy' : '#iconxiugai'" />
        </svg>
        <span :class="{ 'btn-text': true, ban: multipleSelection.length !== 1 }">修改</span>
      </span>
      <span
        placement="top"
        :class="['tooltip', { notclick: iconDel == false }]"
        content="刪除"
        @click="handleDelete()"
      >
        <svg
          class="icon"
          aria-hidden="true"
        >
          <use :xlink:href="multipleSelection.length === 1 && iconDel != false ? '#iconshanchu1-copy' : '#iconshanchu1'" />
        </svg>
        <span :class="{ 'btn-text': true, ban: multipleSelection.length !== 1 || iconDel == false }">刪除</span>
      </span>
      <span
        v-if="isUsePersonnelTransfer || isUsePropertyTransfer"
        placement="top"
        class="tooltip zhuanyi-user"
        content="轉移"
        @click="handleTransfer()"
      >
        <svg
          class="icon"
          aria-hidden="true"
          @click="handleTransfer()"
        >
          <use :xlink:href="multipleSelection.length === 1 ? '#iconzhuanyi-copy' : '#iconzhuanyi'" />
        </svg>
        <span :class="{ 'btn-text': true, ban: multipleSelection.length !== 1 }">{{ isUsePersonnelTransfer && isUsePropertyTransfer ? '轉移樓盤/員工':isUsePropertyTransfer && !isUsePersonnelTransfer ?'轉移樓盤':!isUsePropertyTransfer && isUsePersonnelTransfer?'轉移員工':'' }}</span>
      </span>
    </div>
    <div class="container table">
      <div class="text-list">
        <el-table
          :key="tableKey"
          v-loading="listLoading"
          empty-text="暫無數據"
          class="staffing_table"
          :data="list"
          fit
          :header-cell-style="{ background: 'rgba(80,181,255,0.15)' }"
          @selection-change="sortChange"
        >
          <el-table-column
            v-if="permissions.System_Employee_Manager"
            type="selection"
            width="55"
          />
          <el-table-column
            fixed="right"
            label="操作"
            width="120"
            class-name="fixColumm"
          >
            <template slot-scope="scope">
              <span>
                <el-button
                  :class="['editBut',{disspancol:!(scope.row.isFixDisOth || !isFixDis) }]"
                  type="primary"
                  size="small"
                  @click="handleUpdate(scope.row)"
                >修改</el-button>
              </span>
              <el-dropdown
                ref="dropdown"
                trigger="click"
                :hide-on-click="true"
              >
                <span :class="['marBut',{disspancol:!(scope.row.isFixDisOth || !isFixDis) }]">
                  <el-button
                    class="expandBut"
                    icon="el-icon-caret-bottom"
                    :disabled="!(scope.row.isFixDisOth || !isFixDis) "
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div
                      :class="['span', { disspan: !isUsePropertyTransfer }]"
                      @click="handleTransfer(scope.row,'first')"
                    >
                      <svg
                        class="icon"
                        aria-hidden="true"
                      >
                        <use :xlink:href="!isUsePropertyTransfer ? '#iconzhuanyi' : '#iconzhuanyi-copy'" />
                      </svg>
                      <span :class="{ 'btn-text': true, ban: !isUsePropertyTransfer }">轉移樓盤</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div
                      :class="['span', { disspan: !isUsePersonnelTransfer }]"
                      @click="handleTransfer(scope.row,'second')"
                    >
                      <svg
                        class="icon"
                        aria-hidden="true"
                      >
                        <use :xlink:href="!isUsePersonnelTransfer ? '#iconzhuanyi' : '#iconzhuanyi-copy'" />
                      </svg>
                      <span :class="{ 'btn-text': true, ban: !isUsePersonnelTransfer }">轉移員工</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div
                      :class="['span', { disspan:!(scope.row.status=='Normal' && userInfo.accountID != scope.row.accountID)}]"
                      @click="changeStatus(2,scope.row)"
                    >
                      <svg
                        class="icon"
                        aria-hidden="true"
                      >
                        <use :xlink:href="!(scope.row.status=='Normal' && userInfo.accountID != scope.row.accountID) ? '#icontingyongzhanghu' : '#icontingyongzhanghu-copy'" />
                      </svg>
                      <span :class="{'btn-text': true, ban: !(scope.row.status=='Normal' && userInfo.accountID != scope.row.accountID)}">停用賬戶</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div
                      :class="['span', { disspan: scope.row.status != 'Disable'}]"
                      @click="changeStatus(1,scope.row)"
                    >
                      <svg
                        class="icon"
                        aria-hidden="true"
                      >
                        <use :xlink:href=" scope.row.status!= 'Disable' ? '#iconqiyongzhanghu' : '#iconqiyongzhanghu-copy'" />
                      </svg>
                      <span :class="{ 'btn-text': true, ban: scope.row.status != 'Disable' }">啟用賬戶</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div
                      :class="['span', { disspan: userInfo.accountID == scope.row.accountID }]"
                      @click="handleDelete(scope.row)"
                    >
                      <svg
                        class="icon"
                        aria-hidden="true"
                      >
                        <use :xlink:href=" userInfo.accountID == scope.row.accountID ? '#iconshanchu1' : '#iconshanchu1-copy'" />
                      </svg>
                      <span :class="{ 'btn-text': true ,ban: userInfo.accountID == scope.row.accountID}">刪除</span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <span class="stffedit_sty" @click="handleUpdate(scope.row)">修改</span> -->
            </template>
          </el-table-column>
          <el-table-column
            label="員工姓名"
            prop="name"
            :min-width="9 * 13"
          >
            <template slot-scope="scope">
              <div class="nameTop">
                <!-- <el-tooltip v-if="checklength(scope.row.name) > 13" placement="top" :content="scope.row.name">
                                    <span>{{ scope.row.name ? checkCharacterType(scope.row.name, 13) : '-' }}</span>
                                </el-tooltip> -->
                <span>{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="電話"
            prop="telephone"
            :min-width="6 * 13"
          >
            <template slot-scope="scope">
              <div class="nameTop">
                <span>
                  <!-- {{ scope.row.telephone ? scope.row.telephone.substring(0, 4) + '&nbsp;' + scope.row.telephone.substring(4, 8) : '-' }} -->
                  {{ scope.row.telephone ? '+'+scope.row.phoneCode + '&nbsp;' +scope.row.telephone: '-' }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="WhatsApp"
            prop="WhatsApp"
            width="100"
          >
            <template slot-scope="scope">
              <div class="nameTop">
                <span v-if="scope.row.isShowWhatsApp">
                  <!-- {{ scope.row.telephone ? scope.row.telephone.substring(0, 4) + '&nbsp;' + scope.row.telephone.substring(4, 8) : '-' }} -->
                  {{ scope.row.telephone ? '+'+scope.row.phoneCode +'&nbsp;' + scope.row.telephone: '-' }}
                </span>
                <span v-else>
                  <!-- {{ scope.row.whatsApp ? scope.row.whatsApp.substring(0, 4) + '&nbsp;' + scope.row.whatsApp.substring(4, 8) : '-' }} -->
                  {{ scope.row.whatsApp ? '+'+scope.row.whatsAppCode +'&nbsp;' + scope.row.whatsApp : '-' }}
                </span>
              </div>
            </template>
          </el-table-column>
    
          <el-table-column
            label="電郵"
            :min-width="14 * 13"
            prop="email"
          >
            <template slot-scope="scope">
              <div class="nameTop">
                <!-- <el-tooltip v-if="scope.row.email && scope.row.email.length > 20" placement="top" :content="scope.row.email">
                                    <span>{{ scope.row.email.substring(0, 20) + '...' }}</span>
                                </el-tooltip> -->
                <span>{{ scope.row.email ? scope.row.email : '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="狀態"
            :min-width="5 * 13"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="nameTop">
                <span v-if="scope.row.status === 'Normal'">啟用</span>
                <span v-if="scope.row.status === 'Disable'">停用</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="組別"
            width="240"
          >
            <template slot-scope="scope">
              <div
                v-show="showLine"
                class="proNum_title_box_line"
              />
              <ul
                v-for="(items, index) in scope.row.roleList"
                :key="index"
                class="depart"
              >
                <el-tooltip
                  :disabled="disableAddress"
                  placement="top"
                  :content="items.departmentName"
                >
                  <span @mouseenter="onMouseEnter($event)">{{ items.departmentName }}</span>
                </el-tooltip>
                <!-- <span>{{ items.departmentName }}</span> -->
              </ul>
            </template>
          </el-table-column>
          <el-table-column
            label="角色"
            :min-width="10 * 13"
          >
            <template slot-scope="scope">
              <div
                v-show="showLine"
                class="proNum_title_box_line"
              />
              <ul
                v-for="(items, index) in scope.row.roleList"
                :key="index"
                class="depart"
              >
                <!-- <el-tooltip placement="top" v-if="items.roleName && items.roleName.length > 8" :content="items.roleName">
                                    <span>{{ items.roleName.substring(0, 8) + '...' }}</span>
                                </el-tooltip> -->
                <span>{{ items.roleName }}</span>
              </ul>
            </template>
          </el-table-column>
          <el-table-column
            label="代理人"
            :min-width="10 * 13"
          >
            <template slot-scope="scope">
              <div class="nameTop">
                <span>{{ scope.row.isAgent ? '是' : '否' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isUsedCoin"
            label="金幣"
            width="120"
          >
            <template slot-scope="scope">
              <div
                v-show="showLine"
                class="proNum_title_box_line"
              />
              <ul
                v-for="(items, index) in scope.row.roleList"
                :key="index"
                class="depart"
              >
                <template v-if="(items.roleID==1 || items.roleID==2) &&accountType && getRemainderPropertyCoin('remainderDiamond', items) != '--'">
                  <el-tooltip
                    content="此乃組別的金幣量"
                    placement="top"
                  >
                    <span
                      class="blue_span"
                      @click="goCoinManage(items.accountDepartmentID,0,items.parentID,items.roleID,scope.row.name,items.departmentName,'coin')"
                    >
                      <img
                        style="vertical-align: center; width: 12px; height: 12px"
                        src="@/assets/gold-icon.svg"
                      >
                      <!-- {{ getRemainderPropertyCoin('remainderPropertyCoin',items) }} -->
                      {{ items.remainderPropertyCoin }} <span class="txt_t">(同组共享)</span> 
                    </span>
                  </el-tooltip>
                </template>
                <template v-else>
                  <span
                    :class="['blue_span',{'bla_span':getRemainderPropertyCoin('remainderDiamond', items) == '--' }]"
                    @click="getRemainderPropertyCoin('remainderPropertyCoin', items) === '--' ? showWarning(items) : goCoinManage(items.accountDepartmentID,items.accountID,0,items.roleID)"
                  >
                    <img
                      style="vertical-align: center; width: 12px; height: 12px"
                      src="@/assets/gold-icon.svg"
                    >
                    {{ getRemainderPropertyCoin('remainderPropertyCoin',items) }}
                  </span>
                </template>
              </ul>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isUsedDiamond"
            label="鑽石"
            width="120"
          >
            <template slot-scope="scope">
              <div
                v-show="showLine"
                class="proNum_title_box_line"
              />
              <ul
                v-for="(items, index) in scope.row.roleList"
                :key="index"
                class="depart"
              >
                <template v-if="(items.roleID==1 || items.roleID==2) && accountType && getRemainderPropertyCoin('remainderDiamond', items) != '--' ">
                  <el-tooltip
                    content="此乃組別的鑽石量"
                    placement="top"
                  >
                    <span
                      class="blue_span"
                      @click="goCoinManage(items.accountDepartmentID,0,items.parentID,items.roleID,scope.row.name,items.departmentName,'diamond')"
                    >
                      <img
                        style="vertical-align: center; width: 12px; height: 12px"
                        src="@/assets/diamond-icon.svg"
                      >
                      {{ items.remainderDiamond }}<span class="txt_t">(同组共享)</span> 
                    </span>
                  </el-tooltip>
                </template>
                <template v-else>
                  <span
                    :class="['blue_span',{'bla_span':getRemainderPropertyCoin('remainderDiamond', items) == '--' }]"
                    @click="getRemainderPropertyCoin('remainderDiamond', items) === '--' ? showWarning(items) : goCoinManage(items.accountDepartmentID,items.accountID,0,items.roleID)"
                  >
                    <img
                      style="vertical-align: center; width: 12px; height: 12px"
                      src="@/assets/diamond-icon.svg"
                    >
                    {{ getRemainderPropertyCoin('remainderDiamond',items) }}
                  </span>
                </template>
              </ul>
            </template>
          </el-table-column>
    
          <el-table-column
            label="個人放盤數量"
            width="165"
          >
            <template slot="header">
              <span>個人放盤數量</span>
              <el-button
                v-show="proExp"
                class="btn_open"
                type="text"
                size="mini"
                @click="expandAll('expandedRows')"
              >
                打開
              </el-button>
              <el-button
                v-show="!proExp"
                class="btn_clo"
                type="text"
                size="mini"
                @click="collapseAll('expandedRows')"
              >
                收起
              </el-button>
            </template>
            <template slot-scope="scope">
              <div
                class="proNum_box"
                :data-row-id="scope.row.accountID"
              >
                <div class="proNum_title_box">
                  <span class="proNum_title">總數：</span>
                  <span
                    class="proNum_num"
                    @click="toTransferProperty('owner',scope.row)"
                  >{{ scope.row.propertyNumber }}</span>
                  <span
                    class="proNum_icon"
                    @click="GetUserInfoByAccountID('owner',scope.row.accountID)"
                  >
                    <i
                      v-show="!expandedRows.has(scope.row.accountID)"
                      class="el-icon-caret-bottom"
                    />
                    <i
                      v-show="expandedRows.has(scope.row.accountID)"
                      class="el-icon-caret-right"
                    />
                  </span>
                </div>
                <div
                  v-show="expandedRows.has(scope.row.accountID)"
                  class="proNum_box"
                >
                  <ul
                    v-for="(items, index) in lazyProRoleListMap[scope.row.accountID] || []"
                    :key="index"
                    class="depart"
                  >
                    <span
                      class="blue_span"
                      @click="handleClick('owner', scope.row, items.accountDepartmentID, items.roleID)"
                    >
                      {{
                        ((propertyNumbers[scope.row.accountID] || [])
                          .find(p => p.accountDepartmentID === items.accountDepartmentID))
                          ? (propertyNumbers[scope.row.accountID]
                            .find(p => p.accountDepartmentID === items.accountDepartmentID).propertyNumber)
                          : "--"
                      }}
                    </span>
                  </ul>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="代理樓盤數量"
            width="165"
          >
            <template slot="header">
              <span>代理樓盤數量</span>
              <el-button
                v-show="agentExp"
                class="btn_open"
                type="text"
                size="mini"
                @click="expandAll('agentRows')"
              >
                打開
              </el-button>
              <el-button
                v-show="!agentExp"
                class="btn_clo"
                type="text"
                size="mini"
                @click="collapseAll('agentRows')"
              >
                收起
              </el-button>
            </template>
            <template slot-scope="scope">
              <div
                class="proNum_box"
                :data-row-id="scope.row.accountID"
              >
                <div class="proNum_title_box">
                  <span class="proNum_title">總數：</span>
                  <span
                    class="proNum_num"
                    @click="toTransferProperty('agent',scope.row)"
                  >{{ scope.row.agentPropertyNumber }}</span>
                  <span
                    class="proNum_icon"
                    @click="GetUserInfoByAccountID('agent',scope.row.accountID)"
                  >
                    <i
                      v-show="!agentRows.has(scope.row.accountID)"
                      class="el-icon-caret-bottom"
                    />
                    <i
                      v-show="agentRows.has(scope.row.accountID)"
                      class="el-icon-caret-right"
                    />
                  </span>
                </div>
                <div
                  v-show="agentRows.has(scope.row.accountID)"
                  class="agent_box"
                >
                  <ul
                    v-for="(items, index) in lazyRoleListMap[scope.row.accountID] || []"
                    :key="index"
                    class="depart"
                  >
                    <span
                      class="blue_span"
                      @click="handleClick('agent', scope.row, items.accountDepartmentID, items.roleID)"
                    >
                      {{
                        ((propertyNumbers[scope.row.accountID] || [])
                          .find(p => p.accountDepartmentID === items.accountDepartmentID))
                          ? (propertyNumbers[scope.row.accountID]
                            .find(p => p.accountDepartmentID === items.accountDepartmentID).agentPropertyNumber)
                          : "--"
                      }}
                    </span>
                  </ul>
                </div>
                <!-- <div v-show="agentRows.has(scope.row.accountID)">
                                    <ul class="depart" v-for="(items, index) in scope.row.roleList" :key="index">
                                        <span class="blue_span" @click="handleClick('agent',scope.row, items.accountDepartmentID, items.roleID)">
                                            {{
                                                ((propertyNumbers[scope.row.accountID] || [])
                                                .find(p => p.accountDepartmentID === items.accountDepartmentID))
                                                ? (propertyNumbers[scope.row.accountID]
                                                    .find(p => p.accountDepartmentID === items.accountDepartmentID).agentPropertyNumber)
                                                : "--"
                                            }}
                                        </span>
                                    </ul>
                                </div> -->
              </div>
              <!-- <span class="stffedit_sty" @click="goProTran('agent',scope.row)">{{ scope.row.agentPropertyNumber }}</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom-container">
        <pagination
          class="bottom-right"
          :page.sync="listQuery.pageIndex"
          :total="total"
          :limit.sync="listQuery.pageCount"
          @pagination="getList('pageChange')"
        />
      </div>
    </div>
    <div class="left-right-scorll">
      <span onselectstart="return false">
        <svg
          class="icons"
          aria-hidden="true"
          @click="clicRightScroll('text-list')"
        >
          <use xlink:href="#iconzuo" />
        </svg>
      </span>
      <span onselectstart="return false">
        <svg
          class="icons"
          aria-hidden="true"
          @click="clicLeftScroll('text-list')"
        >
          <use xlink:href="#iconyou" />
        </svg>
      </span>
    </div>
    <!-- 选择分行管理员-->
    <el-dialog
      :title="titleType"
      :visible.sync="selectManager"
      :close-on-click-modal="false"
      width="564px"
      class="assigns-dialog"
    >
      <el-form
        ref="refAllMan"
        required
        :model="allManager"
        label-width="100px"
        :rules="rules"
      >
        <!-- <div class="indexMan" v-for="(count,index) in exchangeMan" :key="'info'+index">
                    <span class="manSpan" v-text="index+1"></span>
                </div>  -->
        <div
          v-for="(item, index) in delStaff"
          :key="index"
        >
          <el-form-item
            v-if="item.manangers && item.manangers.length"
            label=" "
            prop="propertyReceiveID"
          >
            <div>
              <!-- <span class="manSpan" v-text="index"></span> -->
              <span v-text="`${group}${item.manangers[0].departmentName}${fenMan}`" />
            </div>
            <el-select
              v-model="allManager.propertyReceiveID[index]"
              style="width: 100%"
              placeholder="請選擇"
            >
              <el-option
                v-for="(it, ins) in item.manangers"
                :key="ins"
                :label="it.name"
                :value="it.accountID"
                @click.native="setManager(it, index)"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="backOutTime">返回</el-button>
        <el-button
          type="primary"
          @click="nextMan"
        >下一步</el-button>
      </span>
    </el-dialog>
    <!-- 选择代理人 -->
    <el-dialog
      title="尚有顯示該代理聯絡資料的樓盤，需要轉移給其他代理人"
      :visible.sync="selectAgent"
      :close-on-click-modal="false"
      width="564px"
      class="assigns-dialog"
    >
      <el-form
        ref="refAllAgen"
        required
        :model="allAgent"
        label-width="100px"
        :rules="rules"
      >
        <div
          v-for="(item, index) in delStaff"
          :key="index"
        >
          <el-form-item
            v-if="item.havePropertyAgent && item.userAgents.length"
            label=" "
            prop="agentReceiveID"
          >
            <!-- <span>{{ index + 1 }}</span>  -->
            <div>
              <span v-text="`${group}${item.userAgents[0].departmentName}${fenAge}`" />
            </div>
            <el-select
              v-model="allAgent.agentReceiveID[index]"
              style="width: 100%"
              placeholder="請選擇"
            >
              <el-option
                v-for="(it, ins) in item.userAgents"
                :key="ins"
                :label="it.name"
                :value="it.accountID"
                @click.native="setAgent(it, index)"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="backMan">返回</el-button>
        <el-button
          type="primary"
          @click="nextAgent"
        >下一步</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="tran-dialog assigns-dialog"
      title=""
      type="warning"
      :visible.sync="showtransMes"
      :close-on-click-modal="false"
      :show-close="false"
      width="375px"
    >
      <span class="blockspan iconspan">
        <i class="greeicon el-icon-success" />
      </span>
      <span class="blockspan">
        成功停用<br>
        是否需要轉移該員工仍在代理中的有效樓盤？<br>
        <span
          class="blue-link"
          @click="navigateToProtransfer"
        > 轉移樓盤 </span>
      </span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="popertyTransOff"
        >關閉</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination';
import { mapGetters } from 'vuex';
export default {
    name: 'StaffingIndex',
    components: { Pagination },
    data() {
        let isEnTrust = (rule, value, callback) => {
            value = value.filter(d => d);
            if (value.length !== this.exchangeMan.length) {
                callback(new Error('不能为空'));
            } else {
                callback();
            }
        };
        let isAgeTrust = (rule, value, callback) => {
            value = value.filter(d => d);
            if (value.length !== this.exchangeAge.length) {
                callback(new Error('不能为空'));
            } else {
                callback();
            }
        };
        return {
            accountType:true,
            showLine:false,
            lazyProRoleListMap:{},
            lazyRoleListMap:{},
            agentRows: new Set(),
            expandedRows: new Set(), 
            agentExp:true,
            proExp:true,
            propertyNumbers: {}, 
            showRightBtn:false,
            departmentOptions:[],
            disableAddress:true,
            showtransMes:false,
            navigateSel:[],
            transMes:false,
            isUsePropertyTransfer:true,
            isUsePersonnelTransfer:true,
            isUsedCoin:false,
            isUsedDiamond:false,
            // isShowDiamondHistory:false,
            // isShowCoinHistory:false,
            titleType: '',
            exchangeMan: [], //校验时判断managers是否全部填满
            exchangeAge: [],
            /* companyCategory: null, */
            manFlag: false, //是否存在分行管理员哨兵
            ageFlag: false,
            group: '請在組別【',
            fenMan: '】選擇分行管理員',
            fenAge: '】中選擇代理人',
            countMan: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
            delStaff: [], //删除的员工相关数据
            selectManager: false, //分行管理员dialog
            selectAgent: false, //代理人dialog
            users: [],
            searchName: '',
            num: 0,
            iconStart: false,
            iconDisable: false,
            iconDel: false,
            staffOptions: [],
            organizationOptions: [],
            nameOptions:[],
            loading:false,
            roleOptions: [],
            roleIDList: [],
            stateOptions: [
                { value: '', label: '全部' },
                { value: 'Normal', label: '啟用' },
                { value: 'Disable', label: '停用' }
            ],
            agentOptions: [
                { value: true, label: '是' },
                { value: false, label: '否' }
            ],
            tableKey: 0,
            total: 0,
            multipleSelection: [],
            list: [],
            organizations: [],
            roles: [],
            listQuery: {
                roleId: null,
                departmentID: null,
                searchName: '',
                status: '', //默认从启用变全部
                isAgentData:'',
                pageIndex: 1,
                pageCount: 100,
                keyWorld: ''
            },
            accountIDs: [],
            userdetail: {},
            role: false,
            department: false,
            // 滚动值
            scrollValue: 0,
            // 是否置顶
            isTop: false,
            removeAccountID: '', //删除员工id
            containsExpire: false,
            propertyTrans: [
                //可能存在多组
                //     {
                // propertyReceiveID: 0, //分行管理员id
                // departmentID: 0, //分行id
                // containsExpire: false, //是否保留过期楼盘
                // agentReceiveID: 0, //代理人id
                //     }
            ],
            allManager: { propertyReceiveID: [] }, //选中后接收
            allAgent: { agentReceiveID: [] },
            setMan: [], //点击选中某人员后，压入是否保存楼盘过期楼盘
            setAge: [],
            rules: {
                propertyReceiveID: [{ validator: isEnTrust, required: true, message: '請選擇管理員', trigger: ['change'] }],
                agentReceiveID: [{ validator: isAgeTrust, required: true, message: '請選擇代理人', trigger: ['change'] }]
            },
            validsuc: false
        };
    },
    watch: {
        // 監聽滚动
        scrollValue(val) {
            if (this.isMoreChoose) {
                if (val >= 250) {
                    this.isTop = true;
                } else {
                    this.isTop = false;
                }
            } else {
                if (val >= 120) {
                    this.isTop = true;
                } else {
                    this.isTop = false;
                }
            }
        }
    },
    computed: {
        isFixDis() {
            const length = Array.isArray(this.multipleSelection) ? this.multipleSelection.length : 0
            
            if (length >= 1) {
                return true
            }
            return false
        },
        ...mapGetters(['userInfo', 'permissions'])
    },
    created() {
        if (this.$route.params.pageIndex) {
            this.listQuery.pageIndex = this.$route.params.pageIndex;
        }
        this.listQuery.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'staffPageCount') || 100;
        this.getCompanyCofig(); 
        this.getList();
        // this.getStaffOptions();
        this.getOrganizationOptions();
        // 点击展开按钮员工的id
        this.getUserRoles();
        this.getRoleOptions();
    },
    mounted() {
        document.querySelector('.el-main').addEventListener('scroll', this.handleScroll);
        let steps = [
            {
                element: '.add-user',
                popover: {
                    className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'h160',
                    title: '創建多賬戶不同角色',
                    doneBtnText: '下一步',
                    closeBtnText: '關閉'
                }
            },
            {
                element: '.zhuanyi-user',
                popover: {
                    className: !this.$route.params.initiativeGuide ? 'first-guidance' : '',
                    title: '員工可以調動',
                    doneBtnText: '下一步',
                    closeBtnText: '關閉'
                },
                onNext: () => {
                    // this.driver.reset();
                    this.$router.push({
                        name: this.pub.routeNameLists.PropertyIndex,
                        params: {
                            guide: 1,
                            initiativeGuide: this.$route.params.initiativeGuide
                        }
                    });
                }
            }
        ];

        if (this.$route.params.guide) {
            setTimeout(() => {
                this.pub.guide(this.Driver, steps);
            }, 500);
        }
    },
    methods: {
        // inputName(event){
        //     // // 从事件对象中获取输入的值
        //     // let value = event.target.value;
        //     // const trimmed = value.replace(/\s+/g, '');
        //     // this.listQuery.searchName = trimmed;
        //     // 阻止空格键的默认行为
        //     // if (event.key === ' ' || event.keyCode === 32) {
        //     //     event.preventDefault();
        //     //     event.stopPropagation();
        //     //     return false;
        //     // }
        // },
        async expandAll(rowType) {
            try {
                // this.listLoading = true;
                let mapType = '';
                if (rowType == 'expandedRows') {
                    this.proExp = false;
                    mapType = 'lazyProRoleListMap';
                } else {
                    this.agentExp = false;
                    mapType = 'lazyRoleListMap';
                }
                // 复制出一个新 Set
                const newSet = new Set(this[rowType]);
                this.list.forEach(row => {
                    if (!newSet.has(row.accountID)) {
                        newSet.add(row.accountID);
                        if (!this[mapType][row.accountID]) {
                            this.$set(this[mapType], row.accountID, row.roleList || []);
                        }
                    }
                    this.$set(this.propertyNumbers, row.accountID,  row.roleList);
                });
        
                this.showLine = true;
                // 替换引用，触发视图更新
                this[rowType] = newSet;
                // 批量获取用户信息
                // const accountIDs = this.list.map(row => row.accountID);
                // await this.getUserInfoBatch(accountIDs);
            
            } catch (error) {
                console.error( error);
            } finally {
                // this.listLoading = false;
            }
        },
        collapseAll(rowType) {
            if(rowType == 'expandedRows'){
                this.proExp  = true
            }else{
                this.agentExp = true
            }
            this[rowType] = new Set()
            this.showLine = false;
            this.$nextTick(() => {
                const rows = document.querySelectorAll('.el-table__row--expanded');
            });
        },
        // 批量调用接口填充 propertyNumbers
       async  getUserInfoBatch(accountIDs) {
            const promises = accountIDs.map(accountID => {
            return this.axios
                .get(this.pub.getApi().GetUserInfoByAccountID, {
                    params: { accountID }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        const departmentList = res.data.result.roleList.filter(
                            item => item.isLoginDepartmentManager === true
                        );
                        this.$set(this.propertyNumbers, accountID, departmentList);
                    }
                    return res;
                });
            });
            return Promise.all(promises);
        },
        
 
        clicLeftScroll(data) {
            let left = this.$(`.${data} .el-table__body-wrapper `).scrollLeft();
            this.$(`.${data} .el-table__body-wrapper`).animate({ scrollLeft: left + 200 }, 200);
        },
        clicRightScroll(data) {
            let left = this.$(`.${data} .el-table__body-wrapper `).scrollLeft();
            if (left >= 200) {
                this.$(`.${data} .el-table__body-wrapper `).animate({ scrollLeft: left - 200 }, 200);
            } else {
                this.$(`.${data} .el-table__body-wrapper `).animate({ scrollLeft: 0 }, 200);
            }
        },
        async goCoinManage(depId,accountID,parentID,roleId,roleName,depName,typeCD){
            if(roleId == 4 ){return}
            //公司账户 管理员跳转 组别tab 
            if(this.accountType &&( roleId ==1 ||roleId ==2)){
                let res = await this.axios.post(this.pub.getApi().SearchCompanyUserInfo,{
                    departmentID: depId,
                    pageIndex: 1,
                    pageCount: 100,
                    coinMananger:false,
                    status: "normal",
                    roleIdList:[1,2]
                });
                if(res.data.result.count > 1){
                    const index = res.data.result.data.findIndex(item => item.accountID == accountID);
                    if (index !== -1) {
                        res.data.result.data.splice(index, 1);
                    }
                }
                const type = typeCD == 'coin' ? '金幣' : '鑽石'
                const navType = this.isUsedCoin && this.isUsedDiamond ? '金幣/鑽石' : this.isUsedDiamond ? '鑽石' : '金幣';
                const namesList = res.data.result.data.map(item => item.name).join('<br>'); 
                const message = `
                <div>
                    現在將會跳轉到此角色所屬組別(${depName})的${navType}管理頁
                    <div style="color:#222222;margin-top: 8px;">
                        下列同組管理員共享${type}：
                    </div>
                    <div style="max-height: 237px;color:#222222; overflow-y: auto;">
                        ${namesList}
                    </div>
                </div>
                `;
                // 登录为分行角色时，跳转公司账户，此时注意 分行存在parId,但金币钻石管理树形结构并无对应父id，导致无法选中问题。手动清除
                if(depId == this.organizationOptions[0].departmentID){
                    parentID = 0
                }

                this.$confirm(message, '提示', {
                    confirmButtonText: '確認',
                    dangerouslyUseHTMLString: true,
                    showCancelButton: false,
                    type: 'warning'
                }).then(()=>{
                    this.$router.push({ name: this.pub.routeNameLists.CoinIndex, query: { depId: depId ,accId: accountID,parId:parentID,roleId:roleId,roleName:roleName} });
                });
            }else{
                this.$router.push({ name: this.pub.routeNameLists.CoinIndex, query: { depId: depId, accId: accountID } });
            }
        },
        toTransferProperty(type, row, deptID, roleID) {
            localStorage.setItem('userDetail', JSON.stringify(row));
            // 总数跳转，无需配置参数。分数跳转，需要带有参数
            const routeConfig = {
                path: '/staffing/transfer',
                query: { type }
            };
            const typeHandlers = {
                allOwner: () => {},
                allAgent: () => {},
                owner: () => {
                    routeConfig.query.depID = deptID;
                    routeConfig.query.roleID = roleID;
                },
                agent: () => {
                    routeConfig.query.depID = deptID;
                    routeConfig.query.roleID = roleID;
                }
            };
            if (typeHandlers[type]) {
                typeHandlers[type]();
            } else {
                console.warn(`未知的类型: ${type}`);
            }
            this.$router.push(routeConfig);
        },
        handleClick(type,row,deptID,roleID){
            const list = this.propertyNumbers[row.accountID] || [];

            const warnBool = !list.find(p => p.accountDepartmentID === deptID)
            if(warnBool) {
                this.showWarning()
            }else{
                this.toTransferProperty(type,row,deptID,roleID)
            }
        },
        getPropertyNumber(type,departmentId){
            let propertyType = type== 'agent' ? 'agentPropertyNumber' : 'propertyNumber'
            const matchedItem = this.departmentOptions.find(item => 
                item.accountDepartmentID === departmentId
            );
            // 如果找到匹配项，返回属性楼盘数量
            if (matchedItem) {
                return matchedItem[propertyType];
            }
            // 未找到匹配项，返回"--"
            return "--";
        },
        showWarning(items){
            let mes = items && items.roleID == 4 ? '營業助理沒有權限使用金幣或鑽石' : '沒有查看權限'
            this.$message({
                message: mes,
                type: 'warning'
            });
        },
        // 营业助理，禁止跳转
        getRemainderPropertyCoin(type,items){
            const fieldMap = {
                remainderPropertyCoin: 'remainderPropertyCoin',
                remainderDiamond: 'remainderDiamond'
            };
            const field = fieldMap[type];
            if (!field) {return '--';}

            const findNode = (nodes, targetID) => {
                if (!Array.isArray(nodes)) {return null;}
                for (const node of nodes) {
                    if (node.departmentID === targetID) {
                        return node[field];
                    }
                    if (Array.isArray(node.childNode) && node.childNode.length > 0) {
                        const res = findNode(node.childNode, targetID);
                        if (res !== null) {return res;}
                    }
                }
                return null;
            };
            const result = findNode(this.organizationOptions, items.accountDepartmentID);
            // 中间修改为总行分行公司账户 营业助理 -- 
            // if(result !== null && result !== undefined){
            //     if((items.roleID !=4 && !this.accountType)||(this.accountType && items.roleID == 3)){
            //         return items[type]
            //     }else{
            //         return '--'
            //     }
            // }else{
            //    return '--'
            // }
            return result !== null && result !== undefined && items.roleID != 4 ? items[type]: '--';
            // return items.roleID != 4 ? items[type]: '--';
        },
        GetUserInfoByAccountID(type,accountID){
            const rowEl = document.querySelector(`[data-row-id="${accountID}"]`);
            this.showLine = false
            if(type == 'owner'){
                if (this.expandedRows.has(accountID)) {
                    this.expandedRows.delete(accountID);
                } else {
                    if (!this.lazyProRoleListMap[accountID]) {
                        const userRow = this.list.find(r => r.accountID === accountID);
                        this.$set(this.lazyProRoleListMap, accountID, userRow?.roleList || []);
                        this.$nextTick(() => {
                            this.expandedRows.add(accountID); // 确保数据更新完再展开
                        });
                    }else{
                        this.expandedRows.add(accountID);
                    }
                }
            }else{
                if (this.agentRows.has(accountID)) {
                    this.agentRows.delete(accountID);
                } else {
                    if (!this.lazyRoleListMap[accountID]) {
                        const userRow = this.list.find(r => r.accountID === accountID);
                        this.$set(this.lazyRoleListMap, accountID, userRow?.roleList || []);
                        this.$nextTick(() => {
                            this.agentRows.add(accountID);
                        });
                    }else{
                        this.agentRows.add(accountID);
                    }
                }
            }
            if(this.agentRows.has(accountID) || this.expandedRows.has(accountID)){
                this.showLine = true
            }
            this.axios
                .get(this.pub.getApi().GetUserInfoByAccountID, {
                    params: {
                        accountID: accountID
                    }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.departmentOptions =  res.data.result.roleList.filter(item => item.isLoginDepartmentManager === true);
                        const departmentList =  res.data.result.roleList.filter(item => item.isLoginDepartmentManager === true);
                        // this.$forceUpdate();
                        this.$set(this.propertyNumbers, accountID, departmentList); 
                    }
                    }).finally(() => {
                        // 等到表格完全渲染完成再滚动到锚点
                        setTimeout(() => {
                            if (rowEl) {
                                rowEl.scrollIntoView({ behavior: 'auto', block: 'center' });
                            }
                            // rowEl?.scrollIntoView({ behavior: 'auto', block: 'center' });
                        }, 50); // 延时一点，确保 Element UI 内部滚动完成
                    });

        },
        onMouseEnter(e) {
            const target = e.target
            this.disableAddress = target.clientWidth >= target.scrollWidth
        },
        goProTran(val,row){
            localStorage.setItem('userDetail', JSON.stringify(row));
            this.$router.push({ path: '/staffing/transfer',query:{type:val} });
        },
        popertyTransOff(){
            this.showtransMes=false
            this.getList();
        },
        navigateToProtransfer(){
            localStorage.setItem('userDetail', JSON.stringify(this.navigateSel[0]));
            this.$router.push({ path: '/staffing/transfer' });
        },
        clearNo(visible){
            if(!visible){
                this.staffOptions =[];
                this.nameOptions = [];
            }
        },
        async remoteMethods(query) {
       		if (query !== "") {
                // query = query.replace(/\s+/g, '');
                query = query.trim();
                this.listQuery.searchName = query;
                this.loading = true;
                return this.getStaffOptions(query);
            } 
                this.staffOptions =[]
                this.nameOptions = [];
            
        },

        // 判断是否存在代理人和管理员
        manAge() {
            // 是否存在代理人 存在为true
            for (let z = 0; z < this.delStaff.length; z++) {
                //this.delStaff[z].userAgents.length !== 0
                if (this.delStaff[z].userAgents !== null) {
                    this.ageFlag = true;
                    break;
                } else {
                    this.ageFlag = false;
                }
            }
            // 是否存在管理员 存在为true
            for (let i = 0; i < this.delStaff.length; i++) {
                if (this.delStaff[i].manangers !== null) {
                    this.manFlag = true;
                    break;
                } else {
                    this.manFlag = false;
                }
            }
            // 不存在管理员，直接弹出代理人
            if (!this.manFlag && this.ageFlag) {
                this.selectManager = false;
                this.selectAgent = true;
            } else if (this.manFlag) {
                this.selectManager = true;
            }
        },
        editDel() {
            // 有时仍然删除不了 ，可能是 setAge为空导致 具体看数据
            this.setMan.push(...this.setAge);
            // console.log('ediDMans', this.setMan);
            let newArr = [];
            if (this.setMan && this.setMan.length > 0) {
                this.setMan.forEach(function (item, index) {
                    // 避免setMan出现 null，undefined，empty，利用if(item)筛选
                    if (item) {
                        let flag = true;
                        if (newArr.length > 0) {
                            for (let i = 0; i < newArr.length; i++) {
                                if (newArr[i].departmentID == item.departmentID) {
                                    if (item.agentReceiveID) {
                                        newArr[i] = { ...newArr[i], agentReceiveID: item.agentReceiveID };
                                    }
                                    if (item.propertyReceiveID) {
                                        newArr[i] = { ...newArr[i], propertyReceiveID: item.propertyReceiveID };
                                    }
                                    flag = false;
                                    break;
                                }
                            }
                        }
                        if (flag) {
                            newArr.push(item);
                        }
                    }
                });
            }
            this.propertyTrans = newArr;
        },
        error(info) {
            this.$message({
                showClose: true,
                message: info,
                type: 'error',
                offset: document.body.clientHeight / 2
            });
        },
        setAgent(age, index) {
            this.setAge[index] = { departmentID: age.departmentID, agentReceiveID: age.accountID, containsExpire: this.containsExpire };
        },
        setManager(man, index) {
            this.setMan[index] = { departmentID: man.departmentID, propertyReceiveID: man.accountID, containsExpire: this.containsExpire };
            // this.$refs.dataForm.clearValidate('propertyReceiveID');
        },
        validation(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.validsuc = true;
                    return false;
                } 
                    this.validsuc = false;
                
            });
        },
        backOutTime() {
            this.selectManager = false;
            this.$confirm('現在開始刪除員工，是否需要刪除所有已過期的樓盤?', '提示', {
                confirmButtonText: '是,刪除已過期樓盤',
                cancelButtonText: '否,需要保留',
                customClass: 'zidingyi',
                type: 'warning',
                distinguishCancelAndClose: true,
                closeOnClickModal: false
            })
                .then(() => {
                    // 删除已过期的楼盘
                    this.containsExpire = false;
                    //开启分行管理员dialog
                    this.selectManager = true;
                    this.titleType = '刊登中的樓盤，需要轉移給分行管理員';
                })
                .catch(action => {
                    if (action == 'cancel') {
                        this.titleType = '刊登中及已過期的樓盤，需要轉移給分行管理員';
                        this.containsExpire = true;
                        this.selectManager = true;
                    }
                });
        },
        nextMan() {
            this.validation('refAllMan');
            // 没有代理人时 下一步应走金币
            if (this.validsuc) {
                if (this.ageFlag) {
                    this.selectAgent = true;
                } else {
                    if (this.haveCoin || this.haveDiamond) {
                        let desc = '';
                        if (this.haveCoin && !this.haveDiamond) {
                            desc = '剩餘的金幣會回收公司賬戶';
                        } else if (!this.haveCoin && this.haveDiamond) {
                            desc = '剩餘的鑽石會回收公司賬戶';
                        } else if (this.haveCoin && this.haveDiamond) {
                            desc = '剩餘的金幣/鑽石會回收公司賬戶';
                        }
                        this.$confirm(desc, '提示', {
                            confirmButtonText: '下一步',
                            cancelButtonText: '返回',
                            distinguishCancelAndClose: true,
                            closeOnClickModal: false
                        })
                            .then(() => {
                                this.$confirm('是否確認刪除? <br/> 確認後，系統會按你的指示執行，資料將無法復原', '提示', {
                                    confirmButtonText: '確認',
                                    cancelButtonText: '取消',
                                    dangerouslyUseHTMLString: true,
                                    closeOnClickModal: false
                                })
                                    .then(() => {
                                        // console.log('t3', this.propertyTrans, this.multipleSelection[0].accountID);
                                        this.editDel();
                                        // console.log('t33');
                                        this.axios
                                            .post(this.pub.getApi().RemoveUserAllResource, {
                                                removeAccountID: this.multipleSelection[0].accountID,
                                                propertyTrans: this.propertyTrans
                                            })
                                            .then(res => {
                                                if (res.data.code == 0) {
                                                    this.$message({
                                                        type: 'success',
                                                        message: '後台根據配置進行分配並完成刪除做操作',
                                                        showClose: true
                                                    });
                                                }
                                                if (res.data.code == 2040) {
                                                    this.$message({
                                                        type: 'warning',
                                                        message: '暂时无法删除',
                                                        showClose: true
                                                    });
                                                }
                                            });
                                        setTimeout(() => {
                                            this.getList();
                                        }, 500);
                                    })
                                    .catch(() => {
                                        // console.log('c3', this.propertyTrans, this.multipleSelection[0].accountID);
                                        // 此时不存在代理人和放盘人
                                        this.$message({
                                            type: 'info',
                                            message: '不記錄上述配置，並退出操作',
                                            showClose: true
                                        });
                                    });
                            })
                            .catch(action => {
                                if (action === 'cancel') {
                                    this.selectAgent = false;
                                    this.selectManager = true;
                                }
                            });
                    } else {
                        this.$confirm('是否確認刪除?<br/>確認後，系統會按你的指示執行，資料將無法復原', '提示', {
                            confirmButtonText: '確認',
                            cancelButtonText: '取消',
                            dangerouslyUseHTMLString: true,
                            closeOnClickModal: false
                        })
                            .then(() => {
                                // console.log('t6', this.propertyTrans, this.multipleSelection[0].accountID);
                                this.editDel();
                                // console.log('t666');
                                this.axios
                                    .post(this.pub.getApi().RemoveUserAllResource, {
                                        removeAccountID: this.multipleSelection[0].accountID,
                                        propertyTrans: this.propertyTrans
                                    })
                                    .then(res => {
                                        if (res.data.code == 0) {
                                            this.$message({
                                                type: 'success',
                                                message: '後台根據配置進行分配並完成刪除做操作',
                                                showClose: true
                                            });
                                        }
                                        if (res.data.code == 2040) {
                                            this.$message({
                                                type: 'warning',
                                                message: '暂时无法删除',
                                                showClose: true
                                            });
                                        }
                                    });

                                setTimeout(() => {
                                    this.getList();
                                }, 500);
                            })
                            .catch(() => {
                                // console.log('c6', this.propertyTrans, this.multipleSelection[0].accountID);
                                // 此时不存在代理人和放盘人
                                this.$message({
                                    type: 'info',
                                    message: '不記錄上述配置，並退出操作',
                                    showClose: true
                                });
                            });
                    }
                }
                this.selectManager = false;
            }
        },
        backMan() {
            // 没有分行管理员时 跳转 是否删除已过期楼盘
            if (!this.exchangeMan.length) {
                this.selectAgent = false;
                this.$confirm('現在開始刪除員工，是否需要刪除所有已過期的樓盤?', '提示', {
                    confirmButtonText: '是,刪除已過期樓盤',
                    cancelButtonText: '否,需要保留',
                    customClass: 'zidingyi',
                    type: 'warning',
                    distinguishCancelAndClose: true,
                    closeOnClickModal: false
                })
                    .then(() => {
                        this.manAge();
                        // 删除已过期的楼盘
                        this.containsExpire = false;
                        this.titleType = '刊登中的樓盤，需要轉移給分行管理員';
                    })
                    .catch(action => {
                        if (action === 'cancel') {
                            this.containsExpire = true;
                            this.manAge();
                            this.titleType = '刊登中及已過期的樓盤，需要轉移給分行管理員';
                        }
                    });
            } else {
                this.selectManager = true;
                this.selectAgent = false;
            }
        },
        nextAgent() {
            this.validation('refAllAgen');
            if (this.validsuc) {
                this.selectAgent = false;
                if (this.haveCoin || this.haveDiamond) {
                    let desc = '';
                    if (this.haveCoin && !this.haveDiamond) {
                        desc = '剩餘的金幣會回收公司賬戶';
                    } else if (!this.haveCoin && this.haveDiamond) {
                        desc = '剩餘的鑽石會回收公司賬戶';
                    } else if (this.haveCoin && this.haveDiamond) {
                        desc = '剩餘的金幣/鑽石會回收公司賬戶';
                    }
                    this.$confirm(desc, '提示', {
                        confirmButtonText: '下一步',
                        cancelButtonText: '返回',
                        distinguishCancelAndClose: true,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            this.$confirm('是否確認刪除?<br/>確認後，系統會按你的指示執行，資料將無法復原', '提示', {
                                confirmButtonText: '確認',
                                cancelButtonText: '取消',
                                dangerouslyUseHTMLString: true,
                                closeOnClickModal: false
                            })
                                .then(() => {
                                    // console.log('t4', this.propertyTrans, this.multipleSelection[0].accountID);
                                    this.editDel();
                                    // console.log('t4444');
                                    this.axios
                                        .post(this.pub.getApi().RemoveUserAllResource, {
                                            removeAccountID: this.multipleSelection[0].accountID,
                                            propertyTrans: this.propertyTrans
                                        })
                                        .then(res => {
                                            if (res.data.code == 0) {
                                                this.$message({
                                                    type: 'success',
                                                    message: '後台根據配置進行分配並完成刪除做操作',
                                                    showClose: true
                                                });
                                            }
                                            if (res.data.code == 2040) {
                                                this.$message({
                                                    type: 'warning',
                                                    message: '暂时无法删除',
                                                    showClose: true
                                                });
                                            }
                                        });
                                    setTimeout(() => {
                                        this.getList();
                                    }, 500);
                                })
                                .catch(() => {
                                    // console.log('c4', this.propertyTrans, this.multipleSelection[0].accountID);
                                    // 此时不存在代理人和放盘人
                                    this.$message({
                                        type: 'info',
                                        message: '不記錄上述配置，並退出操作',
                                        showClose: true
                                    });
                                });
                        })
                        .catch(action => {
                            // 返回代理人或者分行管理员,还要判断是否有代理人和管理员
                            if (action === 'cancel') {
                                this.selectAgent = true;
                                this.selectManager = false;
                            }
                        });
                } else {
                    this.$confirm('是否確認刪除?<br/>確認後，系統會按你的指示執行，資料將無法復原', '提示', {
                        confirmButtonText: '確認',
                        cancelButtonText: '取消',
                        dangerouslyUseHTMLString: true,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            // console.log('t5', this.propertyTrans, this.multipleSelection[0].accountID);
                            this.editDel();
                            // console.log('t55');
                            this.axios
                                .post(this.pub.getApi().RemoveUserAllResource, {
                                    removeAccountID: this.multipleSelection[0].accountID,
                                    propertyTrans: this.propertyTrans
                                })
                                .then(res => {
                                    if (res.data.code == 0) {
                                        this.$message({
                                            type: 'success',
                                            message: '後台根據配置進行分配並完成刪除做操作',
                                            showClose: true
                                        });
                                    }
                                    if (res.data.code == 2040) {
                                        this.$message({
                                            type: 'warning',
                                            message: '暂时无法删除',
                                            showClose: true
                                        });
                                    }
                                });
                            setTimeout(() => {
                                this.getList();
                            }, 500);
                        })
                        .catch(() => {
                            // console.log('c5', this.propertyTrans, this.multipleSelection[0].accountID);
                            // 此时不存在代理人和放盘人
                            this.$message({
                                type: 'info',
                                message: '不記錄上述配置，並退出操作',
                                showClose: true
                            });
                        });
                }
            }
        },

        // 获取公司配置
        getCompanyCofig() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.isUsePropertyTransfer = res.data.result.isUsePropertyTransfer
                    this.isUsePersonnelTransfer = res.data.result.isUsePersonnelTransfer
                    this.isUsedCoin = res.data.result.isUsedCoin;
                    this.isUsedDiamond = res.data.result.isUsedDiamond;
                    // this.isShowDiamondHistory = res.data.result.isShowDiamondHistory;
                    // this.isShowCoinHistory = res.data.result.isShowCoinHistory;
                    this.accountType =  res.data.result.accountType
                }
            });
        }, 
        // 獲取字符串長度，中占兩個字符，英占一個
        checkCharacterType(str, len) {
            let strlen = 0;
            let s = '';
            for (let i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) > 128) {
                    strlen += 2;
                } else {
                    strlen++;
                }
                s += str.charAt(i);
                if (strlen >= len) {
                    return s + '...';
                }
            }
            return s;
        },
        checklength(str) {
            let strlen = 0;
            for (let i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) > 128) {
                    strlen += 2;
                } else {
                    strlen++;
                }
            }
            return strlen;
        },
        // 角色名稱匹配
        getRoleName(row) {
            for (let i in this.roles) {
                if (this.roles[i].roleID === row.roleID) {
                    return this.roles[i].roleName;
                }
            }
        },
        // 員工下拉
        getStaffOptions(data) {
            this.staffOptions =[]
            this.nameOptions = [];

            this.axios
                .post(this.pub.getApi().SearchDistinctOrganizationUserInfo, {
                    pageIndex: 1,
                    PageCount: 100,
                    searchName:data
                })
                .then(res => {
                    if (res.data.code === 0) {
                        for (let i in res.data.result.data) {
                            if (res.data.result.data[i].name !== null && res.data.result.data[i].name !== undefined && res.data.result.data[i].name !== '') {
                                this.staffOptions.push(res.data.result.data[i]);
                                this.users = this.staffOptions;
                                this.nameOptions = this.staffOptions
                            }
                        }
                    } else {
                        this.nameOptions=[]
                        // res.data.message;
                    }
                    this.loading = false
                    return this.nameOptions

                });
        },
        // 組別下拉
        getOrganizationOptions() {
            this.axios
                .get(this.pub.getApi().GetDepartmentsTreeByParentID, {
                    params: {
                        departmentID: this.userInfo.departmentID
                    }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.organizationOptions.push(res.data.result);
                    }
                });
        },
        // 角色下拉
        getUserRoles() {
            this.axios.get(this.pub.getApi().SerachChildRoleInfoByParentRoleID + `?parentRoleID=${this.userInfo.roleID}`).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.roleOptions = res.data.result;
                }
            });
        },
        // 角色
        getRoleOptions() {
            this.axios
                .post(this.pub.getApi().SerachRoleInfo, {
                    pageIndex: 1,
                    pageCount: 100
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.roles = res.data.result.data;
                    }
                });
        },
        search() {
            this.listQuery.pageIndex = 1;
            // this.listQuery.keyWorld
            // this.listQuery.searchName
            this.getList();
        },
        // 查詢
        getList(type) {
            this.listLoading = true;
            this.axios.post(this.pub.getApi().SearchDistinctOrganizationUserInfo, this.listQuery).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.list = res.data.result.data;
                    this.list.forEach((it, index) => {
                        it['isFixDisOth'] = false; //当选中一个时,其他数据按钮禁用
                    });
                    this.total = res.data.result.count;
                    this.listLoading = false;
                    if(type == 'pageChange'){
                        // 判断当前是否为打开关闭状态
                        // 当为pagesize改变时候，打开维持打开状态，当其他状态进行了table刷新，要重新变为初始化得关闭状态
                        if(!this.agentExp){
                            this.expandAll('agentRows')
                        }
                        if(!this.proExp){
                            this.expandAll('expandedRows')
                        }
                        setTimeout(() => {
                            this.$nextTick(() => {
                                document.querySelector('.el-main').scrollTop = 0;
                            });
                        }, 1000);
                    }else{
                        if(!this.agentExp){
                            this.collapseAll('agentRows')
                        }
                        if(!this.proExp){
                            this.collapseAll('expandedRows')
                        }
                    }
                } else {
                    // res.data.message;
                }
            });
        },
        // table多選
        sortChange(val) {
            this.accountIDs = [];
            this.multipleSelection = val;
            this.iconStart = false;
            this.iconDisable = false;
            this.list.forEach((item, i) => {
                this.$set(this.list[i], 'isFixDisOth', false);
                this.$forceUpdate();
            });
            if (this.multipleSelection.length === 1) {
                this.list.forEach((item, i) => {
                    if (item.accountID === this.multipleSelection[0].accountID) {
                        this.$set(this.list[i], 'isFixDisOth', true);
                        this.$forceUpdate();
                    }
                });
            }
            for (let i = 0; i < val.length; i++) {
                this.accountIDs.push(val[i].accountID);
                if (this.userInfo.accountID == val[i].accountID) {
                    this.iconDel = false;
                } else {
                    this.iconDel = true;
                }
                if (val.length > 1 && val[i + 1]) {
                    if (val[0].status !== val[i + 1].status) {
                        this.iconStart = false;
                        this.iconDisable = false;
                        return false;
                    } else if (val[0].status === 'Normal') {
                        this.iconDisable = true;
                        if (this.userInfo.accountID == val[0].accountID) {
                            this.iconDisable = false;
                        }
                    } else if (val[0].status === 'Disable') {
                        this.iconStart = true;
                    }
                } else if (val.length === 1) {
                    if (val[0].status === 'Normal') {
                        this.iconDisable = true;
                        // 选中自身禁止停用和删除
                        if (this.userInfo.accountID == val[0].accountID) {
                            this.iconDisable = false;
                        }
                        return false;
                    } else if (val[0].status === 'Disable') {
                        this.iconStart = true;
                        return false;
                    }
                } else if (val.length === 0) {
                    this.iconStart = false;
                    this.iconDisable = false;
                }
            }
        },
        // 啟/停用賬戶
        async changeStatus(val,rowVal) {
            let multipleSelectionCopy = []
            let accountIDsCopy = []
            this.navigateSel = []
            if(rowVal){
                // 侧边栏点入
                multipleSelectionCopy.push(rowVal)
                this.navigateSel.push(rowVal)
                accountIDsCopy.push(rowVal.accountID);
            }else{
                multipleSelectionCopy = JSON.parse(JSON.stringify(this.multipleSelection));
                accountIDsCopy = JSON.parse(JSON.stringify(this.accountIDs));
            }
            if (multipleSelectionCopy.length === 0) {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '請至少選擇一條數據',
                        showClose: true
                    });
                }
                return false;
            } 
                let state = '';
                if (val === 1) {
                    state = 'Normal';
                } else if (val === 2) {
                    state = 'Disable';
                }
                for (let i = 0; i < multipleSelectionCopy.length; i++) {
                    for (let j = 0; j < multipleSelectionCopy[i].roleList.length; j++) {
                        this.department = false;
                        this.role = false;
                        this.checkJurisdiction(multipleSelectionCopy[i].roleList[j].accountDepartmentID, multipleSelectionCopy[i].roleList[j].roleID, this.organizationOptions,multipleSelectionCopy[0].accountID);
                    }
                    if (this.department === false || this.role === false) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'error',
                                message: '選擇項中含有員工所在組別或角色級別較高，無權限操作，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    } else if (multipleSelectionCopy[i].status === 'Normal' && state === 'Normal') {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '選擇項中包含已啟用賬戶，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    } else if (multipleSelectionCopy[i].status === 'Disable' && state === 'Disable') {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '選擇項中包含已停用賬戶，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    }
                }
                if (state === 'Disable') {
                    let message;
                    await this.axios.post(this.pub.getApi().SearchUserAllResource,  {accountIds:accountIDsCopy} ).then(res => {
                        //判断当前返回有无有效期楼盘，来给出提示
                        if(res.data.code == 0 && res.data.result){
                            for (let item of res.data.result) {
                                if(item.agentPropertyNumber){
                                    message = '確認停用員工？<br/>停用后，被選中的員工將無法登入PMS，<br/>被選中的員工仍有代理中的有效樓盤，樓盤頁面內的聯絡方式將會暫時隱藏, 請按需要及時處理'
                                    this.transMes= true //当前员工存在楼盘
                                    break;
                                }
                            }
                        }
                        if(!message){
                            message = '確認停用員工？<br/>停用后，被選中的員工將無法登入PMS'
                            this.transMes = false 

                        }
                    });
                    this.$confirm(`${message}`, '提示', {
                        confirmButtonText: '確認',
                        cancelButtonText: '取消',
                        dangerouslyUseHTMLString: true,
                        type: 'warning'
                    })
                        .then(() => {
                            this.axios
                                .post(this.pub.getApi().UpdateUserStatuss, {
                                    accountIDs: accountIDsCopy,
                                    Status: state
                                })
                                .then(res => {
                                    if (res.data.code === 0 && res.data.result) {
                                        if (document.getElementsByClassName('el-message').length === 0) {
                                            this.$message({
                                                type: 'success',
                                                message: '操作成功!',
                                                showClose: true
                                            });
                                        }
                                        if(multipleSelectionCopy.length == 1){
                                            this.showtransMes = this.transMes//选中人员存在楼盘停用后，弹出楼盘转移弹框
                                        }
                                        if(!this.showtransMes){
                                            // 当存在可转移楼盘弹框时，避免点击‘转移楼盘’出现空白页面，更新table放置转移弹框确认按钮
                                            this.getList();
                                        }
                                        // this.$alert('成功停用', '是否需要轉移該員工仍在代理中的有效樓盤？<br/>轉移樓盤', {
                                        //     confirmButtonText: '關閉',
                                        //     dangerouslyUseHTMLString: true,
                                        //     showClose: false
                                        // });
                                    }
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消',
                                showClose: true
                            });
                            return false;
                        });
                } else if (state === 'Normal') {
                    this.axios
                        .post(this.pub.getApi().UpdateUserStatuss, {
                            accountIDs: accountIDsCopy,
                            Status: state
                        })
                        .then(res => {
                            if (res.data.code === 0 && res.data.result) {
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: '操作成功!',
                                        showClose: true
                                    });
                                }
                                this.getList();
                            }
                        });
                }
            
        },
        handleChanges() {
            /* 判断当前选中项是否有子节点，若有不关闭否则关闭下拉面板 */
            const cascaderNodes = this.$refs.cascader.getCheckedNodes();
            if (cascaderNodes.length > 0 && cascaderNodes[0].children.length === 0) {
                this.$refs.cascader.dropDownVisible = false;
            }
        },
        // 重置
        handleReset() {
            this.listQuery = {
                name: '',
                status: '',
                isAgentData:'',
                pageIndex: 1,
                pageCount: 10
            };
            this.getList();
        },
        // 检查权限
        checkJurisdiction(departmentID, roleID, organizationOptions,startId) {
            // console.log('this.userInfo', this.userInfo, 'this.multipleSelection', this.multipleSelection);
            // console.log('departmentID', departmentID, ' roleID', roleID, 'organizationOptions', organizationOptions);
            let startAccountID = startId
            if (!startAccountID && this.multipleSelection && this.multipleSelection.length > 0) {
                startAccountID = this.multipleSelection[0]?.accountID;
            }
            if (this.userInfo.accountID === startAccountID) {
                this.department = true;
                this.role = true;
            } else {
                for (let i = 0; i < organizationOptions.length; i++) {
                    if (departmentID === organizationOptions[i].departmentID) {
                        this.department = true;
                    } else if (organizationOptions[i].childNode && organizationOptions[i].childNode.length > 0) {
                        this.checkJurisdiction(departmentID, roleID, organizationOptions[i].childNode,startId);
                    }
                }
                for (let j = 0; j < this.roleOptions.length; j++) {
                    if (roleID === this.roleOptions[j].roleID) {
                        this.role = true;
                    }
                }
            }
        },
        // 新增
        handleCreate() {
            this.$router.push({ path: '/staffing/create' });
        },
        // 修改
        handleUpdate(val) {
            let editstaff;
            if(val){
                editstaff = val
            }else{
                if (this.multipleSelection.length === 0) {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message({
                            type: 'warning',
                            message: '請至少選擇一條數據',
                            showClose: true
                        });
                    }
                    return false;
                } else if (this.multipleSelection.length > 1) {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message({
                            type: 'warning',
                            message: '只能選擇一條數據',
                            showClose: true
                        });
                    }
                    return false;
                }
                    editstaff = this.multipleSelection[0];
                   
            }
           
            this.roleIDList = editstaff.roleList
            this.roleIDList.forEach((element, index) => {
                this.role = false;
                this.department = false;
                this.checkUser(index, element.accountDepartmentID, element.roleID, this.organizationOptions, this.roleOptions);
                let me = this;
                if (me.roleIDList[index].roleID === 1) {
                    // 角色為總行時不允許編輯
                    me.roleIDList[index].examine = 2;
                } else if (this.department === true && this.role === true) {
                    this.roleIDList[index].examine = 1;
                } else {
                    this.roleIDList[index].examine = 2;
                }
            });
            localStorage.setItem('userDetail', JSON.stringify(editstaff));
            /* localStorage.setItem('companyCategory', JSON.stringify(this.companyCategory)); */
            this.$router.push({
                name: this.pub.routeNameLists.StaffingEdit,
                params:{
                    pageIndex:this.listQuery.pageIndex
                }
                });
            
        },
        checkUser(index, departmentID, roleID, organizationOptions, roleOptions) {
            // 组织
            for (let j = 0; j < organizationOptions.length; j++) {
                if (departmentID === organizationOptions[j].departmentID) {
                    this.department = true;
                    break;
                } else if (organizationOptions[j].childNode && organizationOptions[j].childNode.length > 0) {
                    this.checkUser(index, departmentID, roleID, organizationOptions[j].childNode, roleOptions);
                }
            }
            // 角色
            for (let i = 0; i < roleOptions.length; i++) {
                if (roleID === roleOptions[i].roleID) {
                    this.role = true;
                    break;
                }
            }
        },
        // focusValue(){
        //     if(this.listQuery.searchName !=''){
        //         this.listQuery.searchName = ''
        //     }
        // },
        // selectOne(val) {
        //     if (this.searchName === '' && val.data && val.data === val.target.value) {
        //         this.searchName += val.data;
        //         this.listQuery.searchName = this.searchName;
        //         this.users = this.staffOptions.filter(item => {
        //             if((item.name).toLowerCase().indexOf(val.target.value.toLowerCase()) != -1){
        //                 return true;
        //             }
        //         });
        //     } else if (val.target.value) {
        //         this.listQuery.searchName = val.target.value;
        //         this.users = this.staffOptions.filter(item => {
        //             if((item.name).toLowerCase().indexOf(val.target.value.toLowerCase()) != -1){
        //                 return true;
        //             }
        //         });
        //     } else {
        //         this.listQuery.searchName = '';
        //         this.users = this.staffOptions;
        //     }
        // },
        // getUserLists() {
        //     this.users = this.staffOptions;
        // },
        // 前 删除
        // handleDelete() {
        //     if (this.multipleSelection.length === 0) {
        //         if (document.getElementsByClassName('el-message').length === 0) {
        //             this.$message({
        //                 type: 'warning',
        //                 message: '請至少選擇一條數據',
        //                 showClose: true
        //             });
        //         }
        //         return false;
        //     } else if (this.multipleSelection.length > 1) {
        //         if (document.getElementsByClassName('el-message').length === 0) {
        //             this.$message({
        //                 type: 'warning',
        //                 message: '只能選擇一條數據',
        //                 showClose: true
        //             });
        //         }
        //         return false;
        //     } else {
        //         this.$confirm('此操作將永久刪除該條數據, 是否繼續?', '提示', {
        //             confirmButtonText: '確認',
        //             cancelButtonText: '取消',
        //             type: 'warning'
        //         })
        //             .then(() => {
        //                 console.log("this.multipleSelection",this.multipleSelection,"this.organizationOptions",this.organizationOptions)
        //                 for (var i = 0; i < this.multipleSelection[0].roleList.length; i++) {
        //                     this.department = false;
        //                     this.role = false;
        //                     this.checkJurisdiction(this.multipleSelection[0].roleList[i].accountDepartmentID, this.multipleSelection[0].roleList[i].roleID, this.organizationOptions);
        //                 }
        //                 if (this.department === true && this.role === true) {
        //                     this.axios
        //                         .post(this.pub.getApi().DeleteUserInfo, {
        //                             accountID: this.multipleSelection[0].accountID
        //                         })
        //                         .then(res => {
        //                             if (res.data.code === 0 && res.data.result) {
        //                                 this.$message({
        //                                     type: 'success',
        //                                     message: '刪除成功!',
        //                                     showClose: true
        //                                 });
        //                                 this.getList();
        //                             } else if (res.data.code === 2024) {
        //                                 if (document.getElementsByClassName('el-message').length === 0) {
        //                                     this.$message({
        //                                         type: 'error',
        //                                         message: '該員工擁有金幣或樓盤，請重新選擇！',
        //                                         showClose: true
        //                                     });
        //                                 }
        //                                 return false;
        //                             } else if (res.data.code === 2034) {
        //                                 if (document.getElementsByClassName('el-message').length === 0) {
        //                                     this.$message({
        //                                         type: 'error',
        //                                         message: '該員工擁有代理樓盤，請重新選擇！',
        //                                         showClose: true
        //                                     });
        //                                 }
        //                                 return false;
        //                             }
        //                         });
        //                 } else {
        //                     if (document.getElementsByClassName('el-message').length === 0) {
        //                         this.$message({
        //                             type: 'error',
        //                             message: '該員工所在組別或角色級別較高，無權操作，請重新选择！',
        //                             showClose: true
        //                         });
        //                     }
        //                     return false;
        //                 }
        //             })
        //             .catch(() => {
        //                 this.$message({
        //                     type: 'info',
        //                     message: '已取消刪除',
        //                     showClose: true
        //                 });
        //             });
        //     }
        // },
        // 刪除
        handleDelete(rowVal) {
            let multipleSelectionCopy = []
            if(rowVal){
                multipleSelectionCopy.push(rowVal)
            }else{
                multipleSelectionCopy = JSON.parse(JSON.stringify(this.multipleSelection));
            }
            // else{
            //     multipleSelectionCopy.push(rowVal)
            // }
            // 每一次选择选项置空
            this.allManager.propertyReceiveID = [];
            this.allAgent.agentReceiveID = [];
            this.delStaff = [];
            this.exchangeAge = [];
            this.exchangeMan = [];
            this.setMan = [];
            this.setAge = [];
            this.propertyTrans = [];
            if (multipleSelectionCopy.length === 0) {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '請至少選擇一條數據',
                        showClose: true
                    });
                }
                return false;
            } else if (multipleSelectionCopy.length > 1) {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '只能選擇一條數據',
                        showClose: true
                    });
                }
                return false;
            } 
                // 判断员工是否有关联数据
                this.axios
                    .post(this.pub.getApi().PreRemoveUserAllResource, {
                        accountID: multipleSelectionCopy[0].accountID
                    })
                    .then(res => {
                        if (res.data.code == 2040) {
                            this.$message({
                                type: 'error',
                                message: '該員工所在組別或角色級別較高，無權操作，請重新选择！',
                                showClose: true
                            });
                            return false;
                        } 
                            this.delStaff = res.data.result.pres;
                            this.haveDiamond = res.data.result.haveDiamond;
                            this.haveCoin = res.data.result.haveCoin;
                            // 删掉所有null值
                            for (let i = 0; i < this.delStaff.length; i++) {
                                // 当仅有一个代理人是他自己不允许删除
                                if (this.delStaff[i].userAgents !== null) {
                                    if (this.delStaff[i].userAgents.length == 1 && this.delStaff[i].userAgents[0].accountID == multipleSelectionCopy[0].accountID) {
                                        this.$message({
                                            type: 'error',
                                            message: `該${this.delStaff[i].userAgents[0].departmentName}組別沒有可選代理人,無法繼續進行刪除員工操作!`,
                                            showClose: true
                                        });
                                        return false;
                                    }
                                }
                                /*
                                    众多分行管理员和代理人选项中不能出现被删除员工
                                    利用this.$delete进行了删除 但是页面依然渲染 所以dialog v-if加了长度条件
                                    校验是通过exchangeMan，exchangeAge两个数组，也需要加一个长度判断，通过的才可以压入
                                */
                                if (this.delStaff[i].userAgents !== null) {
                                    for (let j = 0; j < this.delStaff[i].userAgents.length; j++) {
                                        if (this.delStaff[i].userAgents[j].accountID == multipleSelectionCopy[0].accountID) {
                                            this.$delete(this.delStaff[i].userAgents, j);
                                        }
                                    }
                                }
                                if (this.delStaff[i].manangers !== null) {
                                    for (let j = 0; j < this.delStaff[i].manangers.length; j++) {
                                        if (this.delStaff[i].manangers[j].accountID == multipleSelectionCopy[0].accountID) {
                                            this.$delete(this.delStaff[i].manangers, j);
                                        }
                                    }
                                }
                                // 校验时 应判断的长度
                                if (this.delStaff[i].manangers !== null && this.delStaff[i].manangers.length) {
                                    this.exchangeMan.push(this.delStaff[i].manangers);
                                }
                                if (this.delStaff[i].userAgents !== null && this.delStaff[i].userAgents.length) {
                                    this.exchangeAge.push(this.delStaff[i].userAgents);
                                }
                                // 对没有代理人和管理员的项删除 由于length报错，所以先判null和length
                                if ((this.delStaff[i].manangers == null && this.delStaff[i].userAgents == null) || (this.delStaff[i].manangers !== null && this.delStaff[i].manangers.length == 0 && this.delStaff[i].userAgents == null) || (this.delStaff[i].manangers == null && this.delStaff[i].userAgents !== null && this.delStaff[i].userAgents.length == 0) || (this.delStaff[i].manangers == null && this.delStaff[i].userAgents == null && this.delStaff[i].manangers.length == 0 && this.delStaff[i].userAgents.length == 0)) {
                                    this.$delete(this.delStaff, i);
                                    // 由于delstaff删除 长度发生变化 ，所以删除过后对长度进行调整i--
                                    i--;
                                }
                            }
                            // console.log('this.delStaff', this.delStaff);
                            // 如果有分行管理员和代理人可以选择
                            if (this.delStaff.length !== 0) {
                                this.$confirm('現在開始刪除員工，是否需要刪除所有已過期的樓盤?', '提示', {
                                    confirmButtonText: '是,刪除已過期樓盤',
                                    cancelButtonText: '否,需要保留',
                                    customClass: 'zidingyi',
                                    type: 'warning',
                                    distinguishCancelAndClose: true,
                                    closeOnClickModal: false
                                })
                                    .then(() => {
                                        this.manAge();
                                        // 删除已过期的楼盘
                                        this.containsExpire = false;
                                        this.titleType = '刊登中的樓盤，需要轉移給分行管理員';
                                    })
                                    .catch(action => {
                                        if (action === 'cancel') {
                                            this.containsExpire = true;
                                            this.manAge();
                                            this.titleType = '刊登中及已過期的樓盤，需要轉移給分行管理員';
                                        }
                                    });
                            } else {
                                // 当其一个代理盘都没有的时候，直接弹出来金币
                                if (this.haveDiamond || this.haveCoin) {
                                    let desc = '';
                                    if (this.haveCoin && !this.haveDiamond) {
                                        desc = '剩餘的金幣會回收公司賬戶';
                                    } else if (!this.haveCoin && this.haveDiamond) {
                                        desc = '剩餘的鑽石會回收公司賬戶';
                                    } else if (this.haveCoin && this.haveDiamond) {
                                        desc = '剩餘的金幣/鑽石會回收公司賬戶';
                                    }
                                    this.$confirm(desc, '提示', {
                                        confirmButtonText: '下一步',
                                        showCancelButton: false,
                                        closeOnClickModal: false
                                    }).then(() => {
                                        this.$confirm('是否確認刪除?<br/>確認後，系統會按你的指示執行，資料將無法復原', '提示', {
                                            confirmButtonText: '確認',
                                            cancelButtonText: '取消',
                                            dangerouslyUseHTMLString: true,
                                            closeOnClickModal: false
                                        })
                                            .then(() => {
                                                // console.log('t1', this.propertyTrans, this.multipleSelection[0].accountID);
                                                this.editDel();
                                                // console.log('t11111');
                                                this.axios
                                                    .post(this.pub.getApi().RemoveUserAllResource, {
                                                        // 全部选择数据
                                                        removeAccountID: multipleSelectionCopy[0].accountID,
                                                        propertyTrans: this.propertyTrans
                                                    })
                                                    .then(resSource => {
                                                        if (resSource.data.code == 0) {
                                                            this.$message({
                                                                type: 'success',
                                                                message: '後台根據配置進行分配並完成刪除做操作',
                                                                showClose: true
                                                            });
                                                        }
                                                        if (resSource.data.code == 2040) {
                                                            this.$message({
                                                                type: 'warning',
                                                                message: '暂时无法删除',
                                                                showClose: true
                                                            });
                                                        }
                                                    });
                                                setTimeout(() => {
                                                    this.getList();
                                                }, 500);
                                            })
                                            .catch(() => {
                                                // console.log('c1', this.propertyTrans, this.multipleSelection[0].accountID);
                                                // 此时不存在代理人和放盘人
                                                this.$message({
                                                    type: 'info',
                                                    message: '不記錄上述配置，並退出操作',
                                                    showClose: true
                                                });
                                            });
                                    });
                                    // 没有金币或钻石时候 直接弹出最后一步
                                } else {
                                    this.$confirm('是否確認刪除?<br/>確認後，系統會按你的指示執行，資料將無法復原', '提示', {
                                        confirmButtonText: '確認',
                                        cancelButtonText: '取消',
                                        dangerouslyUseHTMLString: true,
                                        closeOnClickModal: false
                                    })
                                        .then(() => {
                                            // console.log('t2', this.propertyTrans, this.multipleSelection[0].accountID);
                                            this.editDel();
                                            // console.log('t22');
                                            this.axios
                                                .post(this.pub.getApi().RemoveUserAllResource, {
                                                    // 全部选择数据
                                                    removeAccountID: multipleSelectionCopy[0].accountID,
                                                    propertyTrans: this.propertyTrans
                                                })
                                                .then(resRemove => {
                                                    if (resRemove.data.code == 0) {
                                                        this.$message({
                                                            type: 'success',
                                                            message: '後台根據配置進行分配並完成刪除做操作',
                                                            showClose: true
                                                        });
                                                    }
                                                    if (resRemove.data.code == 2040) {
                                                        this.$message({
                                                            type: 'warning',
                                                            message: '暂时无法删除',
                                                            showClose: true
                                                        });
                                                    }
                                                });
                                            setTimeout(() => {
                                                this.getList();
                                            }, 500);
                                        })
                                        .catch(() => {
                                            // console.log('c2', this.propertyTrans, this.multipleSelection[0].accountID);
                                            // 此时不存在代理人和放盘人
                                            this.$message({
                                                type: 'info',
                                                message: '不記錄上述配置，並退出操作',
                                                showClose: true
                                            });
                                        });
                                }
                            }
                        
                    });
                for (let i = 0; i < multipleSelectionCopy[0].roleList.length; i++) {
                    this.department = false;
                    this.role = false;
                    this.checkJurisdiction(multipleSelectionCopy[0].roleList[i].accountDepartmentID, multipleSelectionCopy[0].roleList[i].roleID, this.organizationOptions);
                }
            
        },
        // 轉移
        handleTransfer(rowVal,tabname) {
            let multipleSelectionCopy = []
            this.navigateSel = []
            if(rowVal){
                // 侧边栏点入
                this.navigateSel.push(rowVal)
                multipleSelectionCopy.push(rowVal);
            }else{
                multipleSelectionCopy = JSON.parse(JSON.stringify(this.multipleSelection));
            }
            if (multipleSelectionCopy.length === 0) {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '請至少選擇一條數據',
                        showClose: true
                    });
                }
                return false;
            } else if (multipleSelectionCopy.length > 1) {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '只能選擇一條數據',
                        showClose: true
                    });
                }
                return false;
            } 
                localStorage.setItem('userDetail', JSON.stringify(multipleSelectionCopy[0]));
                this.$router.push({ path: '/staffing/transfer' ,query:{'activeName':tabname}});
            
        },
        handleScroll() {
            this.scrollValue = document.querySelector('.el-main').scrollTop;
        }
    }
};
</script>

<style lang="less" scoped>
.blue-link{
    cursor: pointer;
    color: #0062ff;
    text-decoration-line: underline;
    text-decoration-color: #0062ff;
}
.btn-text {
    cursor: pointer;
    position: relative;
    top: 0px;
    font-size: 15px;
    padding-left: 5px;
    color: #0062ff;
}
.ban {
    color: #666;
}
.disspan {
    pointer-events: none;
}
.indexMan {
    position: absolute;
    .manSpan {
        width: 440px;
        height: 80px;
        margin-top: 10px;
    }
}
.staffing-container {
    font-family: PingFangSC-Regular, PingFang SC;
    .title {
        margin: 0 0 20px 0;
        font-size: 24px;
    }
    text-align: left;
    .depart {
        line-height: 15px;
        padding: 0;
        font-size: 14px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        span{
            display: inline-block; /* 或者 block，取决于你的布局需求 */
            white-space: nowrap; /* 防止文本换行 */
            overflow: hidden; /* 隐藏溢出的内容 */
            text-overflow: ellipsis; /* 显示省略号 */
            max-width: 100%; /* 设置最大宽度 */
        }
        // .coinspan{
        //     cursor:pointer;
        // }
        .blue_span{
            color: #0061FF;
            cursor:pointer;
            .txt_t{
                font-size:9px;
                color: rgba(34, 34, 34, 1);
                cursor: pointer;
                vertical-align: middle;
            }
        }
        .bla_span{
            color: rgba(34, 34, 34, 1);
        }
    }
    .proNum_title_box_line{
        height: 23px;
    }
    .btn_open{
        color:#0061FF;
        font-size: 11px;
        margin-left: 10px;
    }
    .btn_clo{
        color: #07D379 ;
        font-size: 11px;
    }
    .proNum_box{
        font-size: 14px;
        height: auto;
        .proNum_num{
            color: #0061FF;
            cursor: pointer;
        }
        .proNum_icon{
            width:10px;
            height: 10px;
            color: #9B9B9B ;
        }
        // .proNum_title_box{
            //float: left;
        // }
    }
    .w160 {
        width: 160px;
    }
    .w120 {
        width: 120px;
    }
    .tran-dialog{
        .greeicon{
            color:#52c41a ;
            font-size: 24px;
            vertical-align: bottom;
        }
        .blockspan{
            display: inline-block;
            vertical-align: top;
        }
        .iconspan{
            margin-right: 10px;
        }
        /deep/.el-dialog{
            border-radius: 10px;
        }
        /deep/ .el-dialog__header{
            display: none;
        }
        /deep/.el-dialog__body{
            line-height: 30px;
            padding-bottom: 0;
        }
    }
    /deep/ .el-input {
        margin-right: 15px;
    }
    .title_index {
        font-size: 24px;
        margin-right: 45px;
    }
    .el-button {
        border-radius: 10px;
    }
    .filter-container {
        padding-bottom: 25px;
        border-bottom: 1px solid #e2e2ea;
        .el-select,
        .el-cascader {
            margin-right: 15px;
        }
        /deep/ .el-input__inner {
            border-radius: 10px;
            border: none;
            color: #000000;
            &::placeholder {
                font-size: 14px;
                color: #666666;
            }
        }
    }
    .operation-container {
        margin: 15px 0;
    }
    .container {
        margin: 20px 0;
        padding: 10px;
        background-color: white;
        border-radius: 20px;
        .editBut {
            width: 52px;
            height: 24px;
            padding: 0;
            text-align: center;
            border-radius: 6px;
        }
        .marBut {
            margin-left: 10px;
        }
        .expandBut {
            margin-left: 0;
            width: 24px;
            height: 24px;
            display: inline-block;
            padding: 0;
            text-align: center;
            border-radius: 6px;
        }
        .disspancol{
            pointer-events: none;
            background-color: #e5e5e5;
            border-color: transparent;
        }
    }
    .stffedit_sty{
        cursor: pointer;
        font-size:14px ;
        color:#0061FF  ;
    }
    .bottom-container {
        padding: 20px 30px 10px;
        .bottom-left {
            text-align: left;
            float: left;
            span {
                font-size: 14px;
                line-height: 30px;
                margin: 0 10px;
            }
        }
        .bottom-right {
            text-align: right;
            padding: 0;
        }
    }
    .search-btn {
        background-color: #e50113;
        border: none;
        width: 88px;
        margin-left: 10px;
    }
    .reset-btn {
        background-color: #bbbbbb;
        border: none;
        color: #ffffff;
        width: 88px;
    }
    .staffing_table {
        width: 99%;
        margin: auto;
    }
    .icon {
        width: 27px;
        height: 23px;
        cursor: pointer;
    }
    .left-right-scorll {
        // width: 100%;
        width: calc(100% - 160px);
        margin-top: 12px;
        height: 24px;
        text-align: center;
        position: fixed;
        bottom: 48px;
        span {
            margin: 0 48px;
            display: inline-block;
            position: relative;
            height: 30px;
            height: 30px;
            width: 52px;
            cursor: pointer;
            overflow: hidden;
            border-radius: 4px;
            &:hover {
                background-color: #ccc;
            }
        }
        .icons {
            font-size: 68px;
            position: absolute;
            left: -6px;
            top: -20px;
            z-index: 99;
            width: 1em;
            height: 1em;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden;
        }
    }
    .operationText-container {
        margin: 15px 0;
        display: none;
    }
    .operationIcon-container {
        margin: 15px 0;
    }
    .line {
        border: 1px solid #e3e3ea;
        height: 20px;
        margin-right: 25px;
        display: inline-block;
    }
    .notclick {
        pointer-events: none;
    }
    .tooltip {
        cursor: pointer;
        margin-right: 25px;
        .btn-text {
            position: relative;
            top: -2px;
            font-size: 15px;
            padding-left: 5px;
            color: #0062ff;
        }
        .ban {
            color: #666;
        }
    }
    // 置頂樣式
    .fixed {
        top: 35px;
        z-index: 999;
        margin-left: -20px;
        padding: 12px 60px 12px 30px;
        width: 100%;
        box-sizing: border-box;
        position: fixed;
        background-color: #f3f3f5;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
    }
    // ---------------------------UI优化
    /deep/.el-table__header-wrapper {
        border-radius: 10px;
        height: 38px;
    }
    /deep/.el-table .cell.el-tooltip {
        position: initial;
    }
    /deep/ .el-table th.el-checkbox:last-of-type {
        position: relative;
    }
    /deep/ .el-table td .el-checkbox:last-of-type {
        // position: absolute;
        // top: 22.5px;
    }
    /deep/.el-table th,
    .el-table tr {
        height: 38px;
        padding: 7px 0;
        font-size: 13px;
        color: #444444;
        font-weight: 400;
    }
    .nameTop {
        // position: absolute;
        // top: 22.5px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #0062ff;
        border-color: #0062ff;
    }
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
        background: rgba(80, 181, 255, 0.1);
    }
    /deep/ .staffing-container .filter-container .el-input__inner {
        color: #666666;
    }
}
</style>

<style lang="less">
.zidingyi {
    .el-message-box__btns {
        button:nth-child(1) {
            width: auto !important;
        }
        button:nth-child(2) {
            width: auto !important;
        }
    }
}
.el-dialog__wrapper {
    transition-duration: 0.3s;
}
.assigns-dialog {
    .el-form-item__label {
        width: 10px !important;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }
    .el-input__inner {
        width: 100% !important;
    }
}
</style>